import { Injectable } from '@angular/core';
import { Observable, BehaviorSubject } from 'rxjs';
import { distinctUntilChanged } from 'rxjs/operators';

@Injectable()
export class BurgerMenuState {
	public showArchived$: Observable<boolean>;
	private showArchived: BehaviorSubject<boolean>;

	public constructor() {
		this.showArchived = new BehaviorSubject(false);
		this.showArchived$ = this.showArchived.asObservable().pipe(distinctUntilChanged());
	}

	public setArchived(visibility: boolean) {
		this.showArchived.next(visibility);
	}
}
